import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useLocation.ts
function useLocation(args, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationProfile.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args && fire
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocation };

//# sourceMappingURL=useLocation.js.map